import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { ModalOptions, BsModalRef } from 'ngx-bootstrap/modal';
import SignaturePad from 'signature_pad';


@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']

})
export class SignaturePadComponent {
  signatureNeeded!: boolean;
  signaturePad!: SignaturePad;
  @ViewChild('canvas', { static: true }) canvasEl!: ElementRef;
  signatureImg!: string;
  // @Output() signatureSaved = new EventEmitter<string>();

  // @ViewChild("canvas", { static: true }) canvas: ElementRef;
  // sig: SignaturePad;
 is_modal: any = false;
  constructor(private options: ModalOptions,
    private datePipe: DatePipe,
    public bsModalRef: BsModalRef) {
    this.is_modal = this.options.initialState.is_modal;
  }


ngOnInit() {
  this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
}

closeWithMessage(message: any) {
  this.bsModalRef.hide();
  this.bsModalRef.onHidden.emit(message);
}
// clear() {
//   this.sig.clear();
// }
startDrawing(event: Event) {
  // works in device not in browser
}
moved(event: Event) {
  // works in device not in browser
}
  savePad() {
    const base64Data = this.signaturePad.toDataURL();
    this.closeWithMessage({message:'success', signature: base64Data});
 }

 getSignature(): string {
  return this.signaturePad.toDataURL(); 
}
 clearPad() {
  this.signaturePad.clear();
}
}
